import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 8px 12px;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px 8px 0 0;
	font-size: 12px;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	color: ${({ theme }) => theme.gray[700]};
	font-weight: 600;
`;

export const HeaderIcon = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
`;

export const Items = styled.ul`
	margin: 0;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: column;
`;

export const Item = styled.li`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 6px 8px 8px;
	color: ${({ theme }) => theme.gray[800]};
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};

	&:last-child {
		border-bottom: none;
	}
`;

export const ItemLabel = styled.span`
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const AttachmentBadge = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 3px;
	flex-shrink: 0;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 11px;
	font-weight: 500;
`;

export const CancelButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	height: 18px;
	padding: 0;
	border: none;
	border-radius: 50%;
	background: transparent;
	color: ${({ theme }) => theme.gray[600]};
	transition: background 0.15s, color 0.15s;

	&:hover {
		background: ${({ theme }) => theme.gray[400]};
		color: ${({ theme }) => theme.gray[1000]};
	}
`;
